import { render, staticRenderFns } from "./RefundEdit.vue?vue&type=template&id=2f8e262b&scoped=true"
import script from "./RefundEdit.vue?vue&type=script&lang=js"
export * from "./RefundEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e262b",
  null
  
)

export default component.exports